import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Autumn/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/1NumbersTo1000000" */ './1NumbersTo1000000'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/2NumbersTo10000000" */ './2NumbersTo10000000'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/3ReadAndWriteNumbersTo10000000" */ './3ReadAndWriteNumbersTo10000000'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year6/Autumn/PlaceValue/4PowersOf10" */ './4PowersOf10')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/5NumberLineTo10000000" */ './5NumberLineTo10000000'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/6CompareAndOrderAnyIntegers" */ './6CompareAndOrderAnyIntegers'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/7RoundAnyInteger" */ './7RoundAnyInteger'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/PlaceValue/8NegativeNumbers" */ './8NegativeNumbers'
        )
    })
  ]
});
export default Block;
